<template>
  <DBox
    :id="'cmp-dtplugins-groups'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_groups')"

    @add_click="addgroupClick"
  >
    <DList
      :items="groups"
      :primaryKey="'group_id'"
      :labelKey="'group_name'"
      :clickable="true"
      @delete="ongroupDelete"
      @item_click="onGroupClick"
    >
    </DList>
  </DBox>
</template>

<script>
import DList from "@dtplugins/list/dlist";
import DBox from "@dtplugins/dbox/dbox";

export default {
  components: {
    DList,
    DBox,
  },
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    contact_id: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    onGroupClick:function(item){
      console.log("WWWW",item)
      this.$emit('groupClick', item);
    },
    addgroupClick: function (event) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_group",
          contact_id: this.contact_id,
        },
      });
    },
    ongroupDelete: function (group) {
      this.$emit("delete", {
        ...group,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-list-item--text {
  // TODO! Change the max-width solution - This is only for 1920px window width. This is not responsive for all window sizes
  // flex: 2.1;
  flex-shrink: 4;
  flex-grow: 4;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  max-width: 350px;
  // max-width: calc(100% / 2);
}
.dt-list-item--icon {
  flex: 0.4;
}
</style>
